module.exports = __webpack_public_path__ + "img/case6.faecfb8f.png";